<template>
    <div class="bg">
        <div class="con">

            <h1>禮包開啟完成</h1>
            <h2>請至您的禮物盒查看</h2>

            <div class="coupon">
                <div class="gift-coupon-item" v-for="(item,index) in list" :key="index">
                    <div class="coupon-cover">
                        <el-image :src="item.titleImage" fit="cover" lazy/>
                    </div>
                    <div class="title">{{item.name}}</div>
                    <div class="sticker-num">{{item.count}}</div>
                </div>
            </div>


            <el-button round type="warning" @click="goGift">前往票券</el-button>

        </div>
        <div class="bo">
            <div class="allPlus" v-for="index in 3" :key="index">
                <i class="circle" v-for="index2 in 10" :key="index2"/>
            </div>
        </div>
    </div>


</template>

<script>

    export default {
        name: "GiftPackAnimation",
        props:['list','isWeb'],
        methods: {
            goGift(){
                if(!this.isWeb){
                    this.$router.push({name:'Gift'})
                }else {
                    //單店網頁版用
                    this.$emit('close');
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .bg{
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: center;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        &::before{
            content: "";
            border-radius: 50%;
            background: rgba(17,0,64,.9);
            width: 80px;
            height: 80px;
            position: fixed;
            left: calc(50% - 40px);
            transform: scale(0);
            animation: bg 1.8s forwards;
        }
        //背景動畫
        @keyframes bg{
            20%{
                transform: scale(0);
            }
            100%{
                transform: scale(30);
            }
        }
        .con{
            text-align: center;
            margin: 20px 0;
            //禮物蓋子
            &::before{
                content: "";
                position: fixed;
                width: 327px;
                height: 226px;
                background: url("../../../assets/images/openGiftAni/gg1.png");
                transform: scale(0);
                left: calc(50vw - 163px);
                top: calc(50vh - 230px);
                z-index: 2;
                animation: box1 2.5s .1s forwards;
            }
            //禮物箱子
            &::after{
                content: "";
                position: fixed;
                width: 320px;
                height: 263px;
                background: url("../../../assets/images/openGiftAni/gg2.png");
                transform: scale(0);
                left: calc(50vw - 156px);
                top: calc(50vh - 165px);
                z-index: 1;
                animation: box2 2.5s .1s forwards;
            }
            //蓋子動畫
            @keyframes box1{
                0%{
                    transform: scale(0);
                }
                18%{
                    transform: scale(.9);
                }
                26%{
                    transform: scale(.7);
                }
                32%{
                    transform: rotate(10deg) scale(.7);
                }
                40%{
                    transform: rotate(-10deg) scale(.8);
                }
                44%{
                    transform: rotate(0) scale(.7);
                }
                52% {
                    transform: rotate(30deg)  scale(.7) translate(0 ,-120px);
                }
                90% {
                    transform: rotate(36deg)  scale(.7) translate(0 ,-150px);
                }
                100% {
                    transform:rotate(26deg) scale(1.5) translate(0 ,-100vh);
                }
            }
            //箱子動畫
            @keyframes box2 {
                0% {
                    transform: scale(0);
                }
                16% {
                    transform: scale(.9);
                }
                26% {
                    transform: scale(.7);
                }
                32% {
                    transform: scale(.7);
                }
                40% {
                    transform: scale(.8);
                }
                44% {
                    transform: scale(.7);
                }
                52% {
                    transform: scale(.7) translate(0 ,150px);
                }
                90% {
                    transform: scale(.7) translate(0 ,170px);
                }
                100% {
                    transform: scale(1.5) translate(0 ,100vh);
                }
            }
            h1{
                font-size: 30px;
                color: #fff;
                opacity: 0;
                animation: an1 .6s 2.5s forwards;
                position: relative;
                z-index: 10;
            }
            h2{
                font-size: 15px;
                color: var(--color-yellow);
                opacity: 0;
                animation: an1 .8s 2.7s forwards;
                position: relative;
                z-index: 10;
            }
            .el-button{
                opacity: 0;
                animation: an1 .8s 2.7s forwards;
                position: relative;
                z-index: 9;
            }
            @keyframes an1{
                0%{
                    opacity: 0;
                }
                100%{
                    opacity: 1;
                }
            }
            .coupon{
                max-height: 60vh;
                margin: 0 0 30px;
                padding: 20px 20px;
                z-index: 3;
                position: relative;
                animation: coupon 0s 2.6s forwards;
                .gift-coupon-item{
                    position: relative;
                    border-radius: 8px;
                    padding: 6px;
                    display: flex;
                    align-items: center;
                    box-shadow: var(--box-shadow);
                    margin: 0 auto 10px;
                    background: #fff;
                    width: 200px;
                    opacity: 0;
                    animation: an2 1.2s 1.4s forwards;
                    .coupon-cover{
                        width: 90px;
                        height: 59px;
                    }
                    .title{
                        flex: 1;
                        text-align: left;
                        font-size: 12px;
                        transform: scale(.9);
                        line-height: 1.4em;
                        color: var(--color-dark2);
                        margin-left: 3px;
                    }
                    //目前數量
                    .sticker-num{
                        color: #fff;
                        position: absolute;
                        left: -10px;
                        top: -5px;
                        font-size: 12px;
                        z-index: 5;
                        background: #D96771;
                        height: 20px;
                        width: 20px;
                        line-height: 20px;
                        border-radius: 50%;
                        text-align: center;
                    }
                }
                @keyframes an2{
                    0%{
                        opacity: 1;
                        transform: scale(.4) rotate(-60deg) translate(130px,-140px);
                        margin-bottom: -60px;
                    }
                    80%{
                        opacity: 1;
                        transform: scale(.4) rotate(-40deg) translate(130px,-150px);
                        margin-bottom: -60px;
                    }
                    100%{
                        opacity: 1;
                        transform: scale(1)  translate(0 ,0);
                    }
                }
            }
            @keyframes coupon{
                0%{
                    overflow: inherit;
                }
                99%{
                    overflow: auto
                }
                100%{
                    overflow: auto
                }
            }
        }
        .bo{
            position: fixed;
            .allPlus{
                position: absolute;
                z-index: 6;
                left: 50vw;
                animation: allPlus 1s 1.2s 2 forwards;
                transform: scale(0);
                &:nth-child(2){
                    animation: allPlus2 1.6s 1.3s forwards;
                    transform : rotate(-120deg) scale(0);
                }
                &:nth-child(3){
                    animation: allPlus3 1.8s 1.5s forwards;
                    transform : rotate(70deg) scale(0);
                }
            }
            @keyframes allPlus{
                0%{
                    transform: scale(0);
                    //opacity: 1;
                }
                50%{
                    transform: scale(1);
                    opacity: 1;
                }
                100%{
                    transform: scale(2.5);
                    opacity: 0;
                }
            }
            @keyframes allPlus2{
                0%{
                    transform:rotate(-120deg) scale(0);
                    //opacity: 1;
                }
                50%{
                    transform:rotate(-120deg) scale(1.2);
                    opacity: 1;
                }
                100%{
                    transform:rotate(-120deg) scale(3);
                    opacity: 0;
                }
            }
            @keyframes allPlus3{
                0%{
                    transform:rotate(70deg) scale(1);
                    //opacity: 1;
                }
                50%{
                    transform:rotate(70deg) scale(1.8);
                    opacity: 1;
                }
                100%{
                    transform:rotate(70deg) scale(3);
                    opacity: 0;
                }
            }
            .el-icon-plus , .circle{
                position: absolute;
                font-size: 16px;
                color: #ff902b;
                border: 2px solid #ff902b;
                border-radius: 50%;
                width: 10px;
                height: 10px;
                z-index: 99;
                margin: -120px 160px;
                //animation: plus .3s infinite;
                &:nth-child(2){
                    color: #dd2875;
                    border-color: #dd2875;
                    margin: -90px;
                    font-size: 18px;
                    width: 13px;
                    height: 13px;
                }
                &:nth-child(3){
                    color: #34a8f1;
                    border-color: #34a8f1;
                    margin: -60px -100px;
                }
                &:nth-child(4){
                    margin: 135px -120px;
                    font-size: 28px;
                    width: 16px;
                    height: 16px;
                }
                &:nth-child(5){
                    color: #dd2875;
                    border-color: #dd2875;
                    margin: -10px -185px;
                    font-size: 26px;
                    width: 14px;
                    height: 14px;
                }
                &:nth-child(6){
                    color: #34a8f1;
                    border-color: #34a8f1;
                    margin: 120px;
                    font-size: 32px;
                    width: 20px;
                    height: 20px;
                }
                &:nth-child(7){
                    margin: -80px 100px;
                    font-size: 32px;
                    width: 20px;
                    height: 20px;
                }
                &:nth-child(8){
                    color: #dd2875;
                    border-color: #dd2875;
                    margin: 40px -40px;
                }
                &:nth-child(9){
                    color: #34a8f1;
                    border-color: #dd2875;
                    margin: -150px 50px;
                    font-size: 32px;
                    width: 16px;
                    height: 16px;
                }
                &:nth-child(10){
                    margin: -20px;
                }
            }
            @keyframes plus{
                0%{
                    transform: rotate(0deg);
                }
                100%{
                    transform: rotate(360deg);
                }
            }
        }
    }


</style>